import { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { EstadosOrdenTrabajoEnumChoice, ROUTER_PATHS } from '@/shared';
import { useGetOrdenTrabajo } from '@/shared/actions/erp';
import { useCheckPermissions, useLoaders } from '@/shared/hooks';
import { AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import {
  SaveOrdenTrabajoAsignadaTec,
  SaveOrdenTrabajoVisitaTec,
} from '../../shared/components';
// OJO (fix merge): el barrel exporta la versión refactorizada de INSTALACIÓN
// (instalacion/containers) que NO tiene el flujo de traslado. El componente con
// el flujo COMPLETO de traslado (inicio/fin con fotos) es este de abajo, que el
// barrel dejó de exportar. Por eso los traslados se enrutan explícitamente aquí.
// Instalación y visitas quedan intactas.
import SaveOrdenTrabajoTrasladoTec from '../../shared/components/SaveOrdenTrabajo/SaveOrdenTrabajoAsignadaTec';
import { MaterialesKey, useMaterialesUtilizadosStore } from '@/store/erp';
import { TipoEntidadOrdenServicioEnumChoice } from '@/shared';

export type InstalacionAsignadaTecnicoPageProps = {};

const InstalacionAsignadaTecnicoPage: React.FC<
  InstalacionAsignadaTecnicoPageProps
> = () => {
  const returnUrlInstalacionesTecnicoPage =
    ROUTER_PATHS.tecnico.ordenenTrabajoNav;
  useCheckPermissions(PermissionsEnum.api_change_ordentrabajo);

  const navigate = useNavigate();

  const clearSelectedItems = useMaterialesUtilizadosStore(s => s.clearSelectedItems);
  const setAlert = useUiStore.getState().setAlert;

  const { id } = useParams();
  const { data, isLoading } = useGetOrdenTrabajo(id!);
  useLoaders(isLoading);

  // validate state
  useEffect(() => {
    clearSelectedItems(MaterialesKey.equipos_utilizados);
    clearSelectedItems(MaterialesKey.materiales_utilizados);
    if (!data?.data?.id_orden_trabajo) return;
    if (
      data?.data?.estado_orden_trabajo !==
      EstadosOrdenTrabajoEnumChoice.EN_ESPERA
    ) {
      setAlert(
        true,
        'La orden de trabajo no tiene el estado correcto',
        AlertSeverityEnum.error
      );
      navigate(returnUrlInstalacionesTecnicoPage);
    }
  }, [data?.data?.id_orden_trabajo]);

  // se comenta el isRefetching x el invalidateQuery en form
  if (isLoading /* || isRefetching */) return null;
  if (!data?.data?.id_orden_trabajo)
    return <Navigate to={returnUrlInstalacionesTecnicoPage} />;

  const tipoServ = data?.data?.agendamiento_data?.tipo_orden_servicio;
  const esVisita = tipoServ === TipoEntidadOrdenServicioEnumChoice.VISITA;
  const esTraslado =
    tipoServ === 'TRASLADO' || (data?.data as any)?.tipo_orden_trabajo === 'TRASLADO';

  if (esVisita) {
    return (
      <SaveOrdenTrabajoVisitaTec
        title="Orden de Trabajo - Técnico"
        ordentrabajo={data?.data}
      />
    );
  }

  if (esTraslado) {
    return (
      <SaveOrdenTrabajoTrasladoTec
        title="Orden de Trabajo - Técnico"
        ordentrabajo={data?.data}
      />
    );
  }

  return (
    <SaveOrdenTrabajoAsignadaTec
      title="Orden de Trabajo - Técnico"
      ordentrabajo={data?.data}
    />
  );
};

export default InstalacionAsignadaTecnicoPage;
